import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { CellContext } from '@tanstack/react-table';

export interface CustomerListHolderFullNameCellProps
  extends CellContext<GatewayCustomerModel, GatewayCustomerModel['holder']> {}

export const CustomerListHolderFullNameCell = (
  props: CustomerListHolderFullNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Text truncate>
      {getValue().firstName} {getValue().lastName}
    </Text>
  );
};
